<template>
	<div>
		<div class="p_flex box_head p_b_b p_f_a">
			<el-tag type="success" size="small " effect="dark">
				{{
					question_type == 1
						? '单选题'
						: question_type == 2
						? '多选题'
						: question_type == 3
						? '判断题'
						: question_type == 4
						? '填空题'
						: question_type == 5
						? '问答题'
						: '材料题'
				}}
			</el-tag>
			<span class="p_m_l_20 type_size_22">1.分值({{ score }}分）</span>
		</div>
		<div v-if="Info.job_type != 2" class="box_head type_size_18" v-html="name"></div>
		<div class="dive">答 :</div>
		<div v-for="(ietm, index) in content" :key="index" class="divs" v-show="content ? true : false">{{ index + 1 }} . {{ ietm.text }}</div>
		<div class="divs" v-show="contents ? true : false">{{ contents }}</div>
		<div class="p_flex" style="flex-wrap: wrap;" v-show="image.length <= 0 ? false : true">
				<el-image  style="width: 100px; height: 100px" v-for="(v,k) in image" :key="k" :src="v"  :preview-src-list="image"> </el-image>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		jsix: null,
		num: null,
		vm: {}
	},
	data() {
		return {
			name: '',
			score: '',
			question_type: '',
			image: [],
			content: [],
			contents: '',
			student_upper: '', //上一个学生id
			student_next: '', //下一个学生id
			student_id: 0,
			question_id: '',
			Info: {}
		};
	},
	watch: {
		jsix: {
			handler(i, o) {
				// console.log(i.id)
				this.question_id = i.id;
				this.get();
			}
		},
		num: {
			handler(i, o) {}
		}
	},
	created() {
		this.$request
			.ajax(this)
			.post('/api_teacher/exercise_problems_correcting_list', {
				job_publish_id: this.$route.query.id
			})
			.then(res => {
				// console.log(res)
				if (res.data.list.length == 0) {
					this.$router.push('/Correct');
					this.$message.error('暂未有要批改的题！');
					return;
				}
				this.question_id = res.data.list[0].id;
				this.get();
			});
	},
	methods: {
		get(id) {
			this.$request
				.ajax(this)
				.post('/api_teacher/exercise_answer_details', {
					type: 2, //1.按学生批改，2.按题目批改
					job_publish_id: this.$route.query.id,
					question_id: this.question_id,
					student_id: this.student_id
				})
				.then(res => {
					console.log(res);
					this.score = res.data.question.score;
					this.question_type = res.data.question.question_type;
					this.name = res.data.question.title;
					this.image = res.data.image;
					this.Info = res.data;
					if (res.data.content instanceof Array) {
						this.content = res.data.content;
						this.contents = '';
					} else {
						this.contents = res.data.content;
						this.content = [];
					}
					this.student_upper = res.data.student_upper; //上一个学生id
					this.student_next = res.data.student_next; //下一个学生id
					this.$emit('uile', res.data.result, this.score, res.data.id, res.data.student_id, res.data);
				});
		},
		getInfo(i) {
			if (i == 1) {
				//上一题
				this.student_id = this.student_upper;
				this.get();
			} else {
				//下一题
				this.student_id = this.student_next;
				this.get();
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.dive {
	margin: 20px 0 0 0;
}
.divs {
	margin: 15px 0 15px 0;
}
>>> .el-tag--dark.el-tag--success {
	background-color: #00af63;
	border-color: #00af63;
}
.box_head {
	padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/correct/commponents/deatils.vue